import { track } from '@fff-web/fff-analytics';
import buttonLabels from '../buttonLabels';
import events from './events';
import CANCEL_FLOW_EXPERIENCE from './experiences';

const MEMBER_TYPES = {
  canceled: 'Canceled Member',
  expired: 'Expired Member',
};

const REACTIVATION_TYPES = {
  canceled: 'Canceled',
  expired: 'Expired',
};

const fireReactivationCompleted = (isExpired: boolean, subscription: string): Promise<void> =>
  track({
    trackName: events.REACTIVATION_COMPLETED,
    properties: {
      cta_name: buttonLabels.CANCEL_BOX,
      experience: CANCEL_FLOW_EXPERIENCE,
      type: isExpired ? MEMBER_TYPES.expired : MEMBER_TYPES.canceled,
      reactivation_type: isExpired
        ? REACTIVATION_TYPES.expired
        : `${REACTIVATION_TYPES.canceled} ${subscription}`,
    },
  });

export default fireReactivationCompleted;
